import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Tooltip, Label, Input } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import EditorContext from '../../containers/editor-context';
var InsertImage = /*#__PURE__*/function (_React$Component) {
  _inherits(InsertImage, _React$Component);
  var _super = _createSuper(InsertImage);
  function InsertImage() {
    var _this;
    _classCallCheck(this, InsertImage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      dropdownOpen: false,
      tooltipOpen: false
    };
    _this.imgToggle = function () {
      _this.setState({
        dropdownOpen: !_this.state.dropdownOpen
      });
    };
    _this.toggle = function () {
      if (_this.props.disabled) {
        _this.setState({
          tooltipOpen: false
        });
        return;
      }
      _this.setState({
        tooltipOpen: !_this.state.tooltipOpen
      });
    };
    _this.uploadLocalImage = function (event) {
      var editor = EditorContext.getEditor();
      if (editor.editorApi.uploadLocalImage) {
        editor.editorApi.uploadLocalImage(event.target.files[0]).then(function (res) {
          _this.props.onInsertImage({
            url: res
          });
        });
      }
    };
    _this.handleFileChange = function (event) {
      _this.uploadLocalImage(event);
      _this.setState({
        dropdownOpen: false
      });
    };
    _this.onInputFile = function (event) {
      event.target.value = null;
      event.nativeEvent.stopImmediatePropagation();
      event.stopPropagation();
    };
    return _this;
  }
  _createClass(InsertImage, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/React.createElement(Dropdown, {
        isOpen: this.state.dropdownOpen,
        toggle: this.imgToggle,
        className: this.props.disabled ? 'upload-localimg upload-localimg-disabled' : 'upload-localimg upload-localimg-hover'
      }, /*#__PURE__*/React.createElement(DropdownToggle, {
        id: this.props.id,
        disabled: this.props.disabled
      }, /*#__PURE__*/React.createElement("i", {
        className: "iconfont icon-image"
      }), /*#__PURE__*/React.createElement(Tooltip, {
        toggle: this.toggle,
        delay: {
          show: 0,
          hide: 0
        },
        target: this.props.id,
        placement: "bottom",
        isOpen: this.state.tooltipOpen
      }, t('insert_image'))), /*#__PURE__*/React.createElement(DropdownMenu, null, /*#__PURE__*/React.createElement(DropdownItem, {
        onClick: this.props.onToggleImageDialog
      }, t('insert_network_image')), !!this.props.insertRepoFile && /*#__PURE__*/React.createElement(DropdownItem, {
        onMouseDown: this.props.insertRepoFile
      }, t('Insert_library_image')), /*#__PURE__*/React.createElement(DropdownItem, {
        className: "image-uploader-btn"
      }, /*#__PURE__*/React.createElement(Label, {
        className: "image-uploader-label",
        for: "image-uploader",
        onClick: this.onInputFile
      }, t('upload_local_image')), /*#__PURE__*/React.createElement(Input, {
        type: "file",
        accept: "image/*",
        onChange: this.handleFileChange,
        onClick: this.onInputFile,
        className: "image-uploader",
        id: "image-uploader"
      }))));
    }
  }]);
  return InsertImage;
}(React.Component);
export default withTranslation('seafile-editor')(InsertImage);